import React, { useEffect } from 'react';
import { toast } from 'react-toastify';
import './Login.css';
import { useDispatch, useSelector } from 'react-redux';
import IState from '../../core/models/IState';
import * as actions from '../../core/actions/actions';
import { withRouter} from 'react-router-dom';
import ILogin from '../../models/ILogin';
import LoginForm from './components/LoginForm';
import RoutesConstants from '../../shared/components/Routes/routes.constants';
import { reset } from 'redux-form';
import { isAuthSelector } from '../../core/selectors/auth.selector';
import meritechLogo from '../../assets/Images/logo/meritech_logo.png';
import { formatMessage } from '../../translations/connectedIntlProvider';
import centraIcon from '../../assets/Images/centra-IoT-icon.png';
import monozLogo from '../../assets/Images/monoZ-Logo.png';
import monozTextLogo from '../../assets/Images/centra-IoT-text-logo.png';


interface IProps {
  history: any;
}


const Login = (props: any) => {

  const { loading, error }: any = useSelector((state: IState) => { return state.auth });
  const isAuthenticated: any = useSelector(isAuthSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(reset('LoginForm'));
      props.history.push(RoutesConstants.Sensor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);


  useEffect(() => {
    if (error) {
      toast.error(formatMessage(error));
    }
  }, [error]);

  const handleLogin = (data: ILogin) => {
    dispatch(actions.login(data));
  }

  return (
    <div className="login-page">




      <div className="login-centra ng-scope" ng-if="!DefaultLogin">
        <div className="login-form">
            <figure>
                <img src={monozLogo} alt="logo" className="img-fluid"></img>
            </figure>
            <div className="login-centra-logo">
                <img src={centraIcon} alt="centra-iot" className="img-fluid"></img>
            </div>
            <div className="default-login-right">
                <div className="centra-logo-text mx-auto">
                  <img src={monozTextLogo} alt="centra-iot" className="img-fluid"></img>
                </div>                
                <LoginForm isLoading={loading} loginHandler={handleLogin} />
            </div>
        </div>
    </div>







    <div className="col-12">
      <div className="copyright2020"> &copy; 2021 Meritech Software Private Limited. All right reserved.</div>
    </div>
      

  </div> 
  )
};

export default withRouter(Login);
